import {createFeatureSelector, createSelector} from "@ngrx/store";
import {CompanyState} from "../states/companyState.state";

export const selectCompanyState = createFeatureSelector<CompanyState>('company');
export const selectCurrenteCompany = createSelector(selectCompanyState, userState => userState.currentCompany);
